var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H14V11.45C14 10.7167 13.6333 10.125 12.9 9.675C12.1667 9.225 11.2 9 10 9C8.8 9 7.83333 9.225 7.1 9.675C6.36667 10.125 6 10.7167 6 11.45V12ZM10 8C10.55 8 11.021 7.804 11.413 7.412C11.8043 7.02067 12 6.55 12 6C12 5.45 11.8043 4.97933 11.413 4.588C11.021 4.196 10.55 4 10 4C9.45 4 8.97933 4.196 8.588 4.588C8.196 4.97933 8 5.45 8 6C8 6.55 8.196 7.02067 8.588 7.412C8.97933 7.804 9.45 8 10 8ZM0 17.575V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H18C18.55 0 19.021 0.195667 19.413 0.587C19.8043 0.979 20 1.45 20 2V14C20 14.55 19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H4L1.7 18.3C1.38333 18.6167 1.02067 18.6873 0.612 18.512C0.204 18.3373 0 18.025 0 17.575ZM2 15.175L3.175 14H18V2H2V15.175Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/Community.b275aacd0befaa336f3b651893b10d75.svg";
export { ForwardRef as ReactComponent };